export default __webpack_public_path__ + "static/media/beeabc.72bd48f9.png";